
export type VerificationStandardId = string;
export type VerificationStandardName = string;

export const VERIFICATION_STANDARDS: Record<VerificationStandardId, VerificationStandardName> = {
  SilvaconsultFCSISO14: 'SILVACONSULT Forest Carbon Standard ISO 14064-2',
  MfKWCH: 'Methodik für Klimaschutzprojekte im Wald für die Schweiz',
};

export const getVerificationStandardName = (id?: string): string => {
  if (!id) return 'Unknown';
  return VERIFICATION_STANDARDS[id] || id;
};
